import {
  getCollabPath,
  getOrgSettingsPath,
  getSharedPath,
  getTrashPath,
  getWorkspacePath,
} from '@/constants/routes';

/**
 * Resolve the safest landing path after accepting a cross-tab workspace sync.
 * Context-authoritative URLs must be remapped so route-derived headers do not
 * keep pointing at the old organization.
 */
export function resolveOrgContextSyncPath(
  pathname: string,
  targetOrgId: string | null
): string | null {
  const [root] = pathname.split('/').filter(Boolean);

  switch (root) {
    case 'workspace':
      return getWorkspacePath(targetOrgId);
    case 'collab':
      return getCollabPath(targetOrgId);
    case 'shared':
      return getSharedPath(targetOrgId);
    case 'trash':
      return getTrashPath(targetOrgId);
    case 'org':
      return targetOrgId ? getOrgSettingsPath(targetOrgId) : getWorkspacePath(null);
    case 'account':
    case 'my-orgs':
    case 'project':
      return getWorkspacePath(targetOrgId);
    default:
      return null;
  }
}
